import { Injectable } from '@angular/core';
import { Property, IProperty, IWizardStep, PROPERTY } from '@clooper/core';
import { FormGroup } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';

@Injectable()
export class PropertyWizardService {

   formInstance = new BehaviorSubject<{ formName: string, formGrp: FormGroup }>(({} as any));
   propertyInstance = new BehaviorSubject<Property>((null as any));

   steps: IWizardStep[] = [
    {
      name: 'Start',
      description: 'Basic information about your property',
      url: '/properties/create',
      viewType: 'all',
      draft_stage: 1
    },
    {
      name: 'Facilities',
      description: 'Basic information about your property',
      url: '/properties/create/indoor',
      viewType: 'all',
      draft_stage: 2
    },
    {
      name: 'Rent',
      description: 'Basic information about your property',
      url: '/properties/create/rent',
      viewType: PROPERTY.OCCUPANCY_TYPES.SINGLE,
      draft_stage: 3
    },
    {
      name: 'Description',
      description: 'Basic information about your property',
      url: '/properties/create/description',
      viewType: PROPERTY.OCCUPANCY_TYPES.SINGLE,
      draft_stage: 4
    },
    {
      name: 'Safety & Compliance',
      description: 'Basic information about your property',
      url: '/properties/create/safety',
      viewType: 'all',
      draft_stage: 5
    },
    {
      name: 'Shared rooms',
      description: 'Let’s know the room you’re leasing out',
      url: '/properties/create/shared-rooms',
      viewType: PROPERTY.OCCUPANCY_TYPES.SHARED,
      draft_stage: 6
    },
    {
      name: 'Media',
      description: 'Basic information about your property',
      url: '/properties/create/media',
      viewType: PROPERTY.OCCUPANCY_TYPES.SINGLE,
      draft_stage: 7
    },
    {
      name: 'Confirmation',
      description: 'Basic information about your property',
      url: '/properties/create/confirm',
      viewType: 'all',
      draft_stage: 8
    },
    {
      name: 'Publish',
      description: '',
      url: '/properties/create/publish',
      viewType: 'all',
      draft_stage: 9
    }
  ];

  currentStep!: IWizardStep;

  constructor(private router: Router) {}

  resumeProperty(property: Property|IProperty) {
    const step = this.steps.find(step => step.draft_stage == property.draft_stage);
    const queryParams = { type: property.occupancy_type }
    this.router.navigate([step?.url, property.id], { queryParams }).then(() => {
      window.location.reload();
    });
  }

}
